export var ReportingManagementRoutes = {
    "/reporting{reportSlug: string}?location_ids&categories_positions&date_type&employee_status&from_date&pay_types&to_date&touchpoint_type&event_type&response_type&tab&reportType&dateType&clockType&punchType&punchStatus&adjustmentType&date&toDate&hoursFormat&employeeReview&timecardStatusCodes&backToSystemView&breakResolution&scheduleBreaksPremiumOwed": {
        "loginRequired": true,
        "showGlobalSearch": true,
        "platformPage": true,
        "name": "appLayout.harriSH.reporting",
        "type": "frontend",
        "component": "reportingManagement",
        "params": {
            reportSlug: {
                value: null,
                dynamic: true,
                raw: true
            },
            location_ids: {
                dynamic: true,
                raw: true
            },
            categories_positions: {
                dynamic: true,
                raw: true
            },
            dateFilterType: {
                dynamic: true,
                raw: true
            },
            employee_status: {
                dynamic: true,
                raw: true
            },
            from_date: {
                dynamic: true,
                raw: true
            },
            pay_types: {
                dynamic: true,
                raw: true
            },
            to_date: {
                dynamic: true,
                raw: true
            },
            touchpoint_type: {
                dynamic: true,
                raw: true
            },
            event_type: {
                dynamic: true,
                raw: true
            },
            response_type: {
                dynamic: true,
                raw: true
            },
            tab: {
                dynamic: true,
                raw: true
            },
            reportType: {
                dynamic: true,
                raw: true
            },
            dateType: {
                dynamic: true,
                raw: true
            },
            clockType: {
                dynamic: true,
                raw: true
            },
            punchType: {
                dynamic: true,
                raw: true
            },
            punchStatus: {
                dynamic: true,
                raw: true
            },
            adjustmentType: {
                dynamic: true,
                raw: true
            },
            date: {
                dynamic: true,
                raw: true
            },
            toDate: {
                dynamic: true,
                raw: true
            },
            backToSystemView: {
                dynamic: true,
                raw: true
            },
            hoursFormat: {
                dynamic: true,
                raw: true
            },
            employeeReview: {
                dynamic: true,
                raw: true
            },
            timecardStatusCodes: {
                dynamic: true,
                raw: true
            },
            breakResolution: {
                dynamic: true,
                raw: true
            },
            scheduleBreaksPremiumOwed: {
                dynamic: true,
                raw: true
            },
        },
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["reporting", "save_views"]
        },
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "Harri | Reports"
            }
        ],
        "route_dependencies": [
            {
                type: 'chunk',
                loader: function () {
                    return import("./reporting-management.module.js");
                }
            },
            {
                type: 'chunk',
                loader: function () {
                    return import("../save-views/save-views.module.js");
                }
            },
            {path: "d3", type: "library", "name": "d3"},
            {path: "c3", type: "library", "name": "c3"}
        ],
        "onEnter": ['hUser', '$state', function (hUser, $state) {
            if (!hUser.hasSalesAccess()) {
                $state.go('appLayout.harriSH.dashboard');
            }
        }],
    },
    "/rating-reports{reportSlug: string}?location_ids&categories_positions&date_type&employee_status&from_date&pay_types&to_date&touchpoint_type&event_type&response_type": {
        "loginRequired": true,
        "showGlobalSearch": true,
        "name": "appLayout.harriSH.engagement-ratings",
        "type": "frontend",
        "component": "reportingManagement",
        "params": {
            reportSlug: {
                value: null,
                dynamic: true,
                raw: true
            },
            location_ids: {
                dynamic: true,
                raw: true
            },
            categories_positions: {
                dynamic: true,
                raw: true
            },
            dateFilterType: {
                dynamic: true,
                raw: true
            },
            employee_status: {
                dynamic: true,
                raw: true
            },
            from_date: {
                dynamic: true,
                raw: true
            },
            pay_types: {
                dynamic: true,
                raw: true
            },
            to_date: {
                dynamic: true,
                raw: true
            },
            touchpoint_type: {
                dynamic: true,
                raw: true
            },
            event_type: {
                dynamic: true,
                raw: true
            },
            response_type: {
                dynamic: true,
                raw: true
            },
        },
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["reporting", "save_views"]
        },
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "Harri | Reports"
            }
        ],
        "route_dependencies": [
            {
                type: 'chunk',
                loader: function () {
                    return import("./reporting-management.module.js");
                }
            },
            {
                type: 'chunk',
                loader: function () {
                    return import("../save-views/save-views.module.js");
                }
            },
            {path: "d3", type: "library", "name": "d3"},
            {path: "c3", type: "library", "name": "c3"}
        ],
        "onEnter": ['hUser', '$state', function (hUser, $state) {
            if (!hUser.hasSalesAccess()) {
                $state.go('appLayout.harriSH.dashboard');
            }
        }],
    },
    "/non-ratings-reports{reportSlug: string}?location_ids&categories_positions&date_type&employee_status&from_date&pay_types&to_date&touchpoint_type&event_type&response_type": {
        "loginRequired": true,
        "showGlobalSearch": true,
        "name": "appLayout.harriSH.engagement-non-ratings",
        "type": "frontend",
        "component": "reportingManagement",
        "params": {
            reportSlug: {
                value: null,
                dynamic: true,
                raw: true
            },
            location_ids: {
                dynamic: true,
                raw: true
            },
            categories_positions: {
                dynamic: true,
                raw: true
            },
            dateFilterType: {
                dynamic: true,
                raw: true
            },
            employee_status: {
                dynamic: true,
                raw: true
            },
            from_date: {
                dynamic: true,
                raw: true
            },
            pay_types: {
                dynamic: true,
                raw: true
            },
            to_date: {
                dynamic: true,
                raw: true
            },
            touchpoint_type: {
                dynamic: true,
                raw: true
            },
            event_type: {
                dynamic: true,
                raw: true
            },
            response_type: {
                dynamic: true,
                raw: true
            },
        },
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["reporting", "save_views"]
        },
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "Harri | Reports"
            }
        ],
        "route_dependencies": [
            {
                type: 'chunk',
                loader: function () {
                    return import("./reporting-management.module.js");
                }
            },
            {
                type: 'chunk',
                loader: function () {
                    return import("../save-views/save-views.module.js");
                }
            },
            {path: "d3", type: "library", "name": "d3"},
            {path: "c3", type: "library", "name": "c3"}
        ],
        "onEnter": ['hUser', '$state', function (hUser, $state) {
            if (!hUser.hasSalesAccess()) {
                $state.go('appLayout.harriSH.dashboard');
            }
        }],
    },
    "/engagement-reports{reportSlug: string}?location_ids&categories_positions&date_type&employee_status&from_date&pay_types&to_date&touchpoint_type&event_type&response_type": {
        "loginRequired": true,
        "showGlobalSearch": true,
        "name": "appLayout.harriSH.surveys",
        "type": "frontend",
        "component": "reportingManagement",
        "params": {
            reportSlug: {
                value: null,
                dynamic: true,
                raw: true
            },
            location_ids: {
                dynamic: true,
                raw: true
            },
            categories_positions: {
                dynamic: true,
                raw: true
            },
            dateFilterType: {
                dynamic: true,
                raw: true
            },
            employee_status: {
                dynamic: true,
                raw: true
            },
            from_date: {
                dynamic: true,
                raw: true
            },
            pay_types: {
                dynamic: true,
                raw: true
            },
            to_date: {
                dynamic: true,
                raw: true
            },
            touchpoint_type: {
                dynamic: true,
                raw: true
            },
            event_type: {
                dynamic: true,
                raw: true
            },
            response_type: {
                dynamic: true,
                raw: true
            },
        },
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["reporting", "save_views"]
        },
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "Harri | Reports"
            }
        ],
        "route_dependencies": [
            {
                type: 'chunk',
                loader: function () {
                    return import("./reporting-management.module.js");
                }
            },
            {
                type: 'chunk',
                loader: function () {
                    return import("../save-views/save-views.module.js");
                }
            },
            {path: "d3", type: "library", "name": "d3"},
            {path: "c3", type: "library", "name": "c3"}
        ],
        "onEnter": ['hUser', '$state', function (hUser, $state) {
            if (!hUser.hasSalesAccess()) {
                $state.go('appLayout.harriSH.dashboard');
            }
        }],
    },
};
